import { CaseInsensitiveMap } from "Global/Base/DataTypes/CaseInsensitiveMap";

export class ErrorMessages {
    private _errorCodeLocalizationMap = new CaseInsensitiveMap([
        ["EmptyUserName", "GUI-375782"], // Uživatelské jméno není vyplněno!
        ["UserNotFound", "GUI-98661"], // Chybné jméno nebo heslo
        ["PasswordChangeRequired", "GUI-678728"], // Systém vyžaduje změnu hesla. Tlačítkem níže jej můžete změnit.
        ["UserMustChangePassword", "GUI-678728"], // Systém vyžaduje změnu hesla. Tlačítkem níže jej můžete změnit.
        ["PasswordExpired", "GUI-678728"], // Systém vyžaduje změnu hesla. Tlačítkem níže jej můžete změnit.
        ["AccountNotActivated", "GUI-177012"], // Účet není aktivován.
        ["AccountExpired", "GUI-203846"], // Platnost účtu vypršela.
        ["AccountLocked", "GUI-203848"], // Účet byl uzamčen.
        ["InvalidDomain", "GUI-604573"], // Přihlašování uživatelů z uvedené domény není povoleno.
        ["AccessDenied", "GUI-169754"], // Uživatel nemá přístup k aplikaci.
        ["PasswordMismatchedPolicy", "GUI-585677"], // Vaše nové heslo nesplňuje pravidla pro tvorbu hesla.
        ["WrongOldPassword", "GUI-585769"], // Neplatné staré heslo.
        ["PasswordAlreadySet", "GUI-679789"], // Nové heslo nesmí být stejné jako původní heslo.
        ["PasswordChangeFailed", "GUI-203854"], // Nepodařilo se změnit heslo
        ["LogonLimitExceeded", "GUI-177008"], // Překročen limit počtu přihlášených uživatelů
        ["NoCookieError", "GUI-98661"], // Chybné jméno nebo heslo
        ["InvalidCredentials", "GUI-98661"], // Chybné jméno nebo heslo
        ["Invalid2FAKey", "GUI-690161"], // Byl zadán nesprávný kód.
        ["KeyExpired", "GUI-685620"], // Vypršela platnost klíče.
        ["KeyLimitExceeded", "GUI-685621"], // Byl překročen limit pokusů o ověření.
        ["DBError", "GUI-685622"], // Nebyl nalezen žádný záznam.
        ["InvalidToken", "GUI-687116"], // Ověření uživatele se nezdařilo.
        ["InvalidCredentials", "GUI-98661"], // Chybné jméno nebo heslo
        ["Undefined", "IP2FA-687248"], // "Výsledek operace není známý."

        ["InvalidKey", "IP2FA-687250"], // "Verifikační klíč není správný."
        ["InvalidID", "IP2FA-687251"], // "Identifikátor klíče není správný."
        ["RequestTimeout", "IP2FA-687252"], // "Vypršela platnost žádosti o ověření."
        ["LimitExceeded", "IP2FA-687253"], // "Byl přesáhnut limit pokusů o přihlášení."
        ["TemporaryKeyLimitExceeded", "IP2FA-687256"], // "Byl přesáhnut limit pro vygenerování nového klíče. Zkuste operaci později."
        ["MessageNotSent", "IP2FA-687257"], // "Zprávu s klíčem se nepodařilo odeslat."
    ]);

    public get errorCodeLocalizationMap(): Map<string, string> {
        return this._errorCodeLocalizationMap;
    }
}
